// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes circular-animation-1864f698{to{stroke-dashoffset:0}}.wechat-button[data-v-1864f698]{cursor:pointer;padding:0 10px;width:-moz-fit-content;width:fit-content}.wechat-button .wrapper[data-v-1864f698]{align-items:center;background-color:#000;border-radius:40px;color:#fff;display:flex;flex-direction:row;height:100%;justify-content:center;padding:15px 40px}.wechat-button .wrapper .text[data-v-1864f698]{font-size:18px;font-weight:700;padding:0 10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
